import React from 'react';
import styles from './CustomFooter.module.css';
import CustomImage from '../customImage/CustomImage';
import DeriLogo from '../../assets/logos/DERi_hor_logo_footer.png';
import { useTranslation } from 'react-i18next';
import CustomButton from '../customButton/CustomButton';
import { ReactComponent as ArrowRightLight } from '../../assets/icons/arrow_right_light.svg';
import { useNavigate } from 'react-router-dom';

const CustomFooter = () => {

    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <footer className={styles.container}>
            <div className={styles.content}>
                <div className={styles.content_block}>
                    <div className={styles.img_container}>
                        <CustomImage src={DeriLogo} alt={t('general.deri_logo')} />
                    </div>

                    <p className={styles.paragraph}>{t('footer.paragraph')}</p>
                </div>

                <div className={styles.content_block}>
                    <p>{t('footer.contact')}</p>
                    <b className={styles.email}>contact@deri.com</b>
                    <CustomButton
                        buttonType="outlined"
                        color="#FFFFFF"
                        endIcon={<ArrowRightLight />}
                        onClick={() => console.log()}>
                        {t('footer.contact_us')}
                    </CustomButton>
                </div>

                <div className={styles.content_block}>
                    <ul className={styles.menu}>
                        <li onClick={() => navigate('/solution')} role='button' tabIndex={0}>{t('footer.menu.solution')}</li>
                        <li onClick={() => navigate('/our_story')} role='button' tabIndex={0}>{t('footer.menu.our_story')}</li>
                        <li onClick={() => navigate('/for_whom')} role='button' tabIndex={0}>{t('footer.menu.for_whom')}</li>
                        <li onClick={() => console.log('')} role='button' tabIndex={0}>{t('footer.menu.handipulse')}</li>
                        <li onClick={() => navigate('/store')} role='button' tabIndex={0}>{t('footer.menu.store')}</li>
                        <li onClick={() => console.log('')} role='button' tabIndex={0}>{t('footer.menu.press_space')}</li>
                        <li onClick={() => navigate('/login')} role='button' tabIndex={0}>{t('footer.menu.login')}</li>
                    </ul>
                </div>
            </div>

            <div className={styles.copy_container}>
                <div className={styles.copy_block}>
                    <span className={styles.copy}>Deri © 2025</span>
                    <span>{t('footer.created_by')}</span>
                </div>

                <div className={styles.copy_block}>
                    <span>{t('footer.legal_notices')}</span>
                </div>
            </div>
        </footer>
    );
};

export default CustomFooter;